import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setSessionCookie } from '../../utils/sessionCookie'
import { useDispatch } from 'react-redux'
import { cabAction } from '../../store/Cab/CAbReducer'
import { clearSessionStorageSafe, removeCabSearchResult } from '../../utils/clientStorage'
import Navbar from '../../layout/Navbar'
import Main from './Main'
// import ServiceSection from './ServiceSection'
import StatisticSection from './StatisticSection'
import PopularRoutes from './PopularRoutes'
// import BlogSection from './BlogSection'
import WhyChooseUs from './WhyChooseUs'
import Testimonials from './Testimonials'
import MediaCoverage from './MeidaCoverage'
// import DownloadSection from '../../layout/downloadSection'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'

function Home() {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    setSessionCookie()
  }, [])

  useEffect(() => {
    clearSessionStorageSafe()
    removeCabSearchResult()
    dispatch(cabAction.resetCabBookingContext())
  }, [dispatch])

  const seo = getSEOData('home');
  const routePrefill = location.state?.routePrefill || null

  return (
    <div className='home'>
      <SEO
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />
      <Navbar page='home'></Navbar>
      <Main routePrefill={routePrefill}></Main>
      {/* <ServiceSection></ServiceSection> */}
      <PopularRoutes />
      <StatisticSection></StatisticSection>
      {/* <BlogSection></BlogSection> */}
      {/* <Client></Client> */}

      <MediaCoverage ></MediaCoverage>
      <WhyChooseUs></WhyChooseUs>
      <Testimonials></Testimonials>
      {/* <Review></Review> */}

      {/* <DownloadSection></DownloadSection> */}
      <Footer></Footer>
    </div>
  )
}

export default Home